import BaseWrapper from 'creative-ui/oktaComponents/BaseWrapper';
import SuccessScreen from 'creative-ui/oktaComponents/SuccessScreen';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import motDePasseMisAJourSvg from '@/assets/mot-de-passe-mis-a-jour.svg';
import { BackToLogin } from '@/components/Buttons/BackToLogin';
import { useTransactionLocale } from '@/hooks/useTranslationLocale';
import { trackPageView } from '@/lib/tagging';

// Main Reset Password Success Screen
function ResetPasswordSuccessScreen() {
  const { t } = useTranslation('resetPasswordSuccess');
  useTransactionLocale();

  useEffect(() => {
    trackPageView('change/password/success');
  }, []);

  const title = t('header.title');

  document.title = t('pageTitle');

  return (
    <BaseWrapper>
      <SuccessScreen
        title={title}
        image={motDePasseMisAJourSvg}
        text={t('description')}
        isTextBeforeImage={false}>
        <BackToLogin variant="primary" />
      </SuccessScreen>
    </BaseWrapper>
  );
}

export default ResetPasswordSuccessScreen;
